var _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.6C4.50294 15.6 4.1 16.0029 4.1 16.5C4.1 16.9971 4.50294 17.4 5 17.4V15.6ZM14 17.4C14.4971 17.4 14.9 16.9971 14.9 16.5C14.9 16.0029 14.4971 15.6 14 15.6V17.4ZM5 17.4H14V15.6L5 15.6V17.4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.6C9.50294 6.6 9.1 7.00294 9.1 7.5C9.1 7.99706 9.50294 8.4 10 8.4V6.6ZM19 8.4C19.4971 8.4 19.9 7.99706 19.9 7.5C19.9 7.00294 19.4971 6.6 19 6.6V8.4ZM10 8.4L19 8.4V6.6L10 6.6V8.4Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16.5,
    r: 4,
    transform: "rotate(-180 18 16.5)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7.5,
    r: 4,
    transform: "rotate(-180 6 7.5)",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.4c82b3d3.svg";
export { ForwardRef as ReactComponent };